document.addEventListener('DOMContentLoaded', () => {

  /* ── Mobile menu ── */
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav    = document.querySelector('[data-mobile-nav]');
  const label  = document.querySelector('[data-menu-label]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Close' : 'Menu';
    });
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target) && !toggle.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = 'Menu';
      }
    });
  }

  /* ── Scroll reveal ── */
  const reveals = document.querySelectorAll('.nf-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  /* ── Sticky header shadow on scroll ── */
  const header = document.querySelector('.nf-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.borderBottomColor = window.scrollY > 10 ? 'rgba(255,255,255,0.08)' : '';
    }, { passive: true });
  }

});
